import React, {useState} from 'react';
import { Card, Table, List, Switch, Divider, Typography, Row, Statistic } from 'antd';
import {stringMixin} from "../../../utils/strings";
import PnL from "../../../Components/PnL";
import {CaretUpOutlined, CaretDownOutlined} from "@ant-design/icons";
import {useEnsureTickersLoaded} from "../../../Hooks/useEnsureTickersLoaded";
import TickerChip from "../../../Components/TickerChip";


const PrefixIcon = ({value}) => {
    return value > 0 ? <CaretUpOutlined style={{color: '#04AB7D'}} /> : <CaretDownOutlined style={{color: 'red'}} />;
}

const PortfolioSnapshotResult = ({ row, extraHeaders }) => {
  const [date, portfolioValue, snapshot, benchmarkValue, ...extraTickers] = row;
  const [showZeros, setShowZeros] = useState(false);
  const snapshotData = Object.entries(snapshot).map(([ticker, details], index) => ({
    key: index,
    ticker,
    weight: details.wgt,
    value: details.val,
  })).sort((a, b)=>b.weight - a.weight);
  const filteredSnapshotData = snapshotData.filter((d) => d.weight > 0 || showZeros);
  const uniqueTickers = new Set(filteredSnapshotData.map((d) => d.ticker));
  const { tickers  } = useEnsureTickersLoaded(Array.from(uniqueTickers));


  const columns = [
    {
      title: 'Ticker',
      dataIndex: 'ticker',
      key: 'ticker',
      render: (text) => <TickerChip ticker={tickers.find(x => text === x.symbol)} />,
    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      key: 'weight',
      render: (text) => stringMixin.pct(text),
    },
    {
      title: 'Return',
      dataIndex: 'ticker',
      key: 'return',
      render: (text, record, index) => {
        const extraIndex = extraHeaders.indexOf(text);
        return extraIndex !== -1 ? <PnL value={row[extraIndex + 3]} /> : null;
      },
    },
  ];


  return (
    <Card
        bordered={false}
        title={date}
        extra={<Switch
            defaultChecked={showZeros}
            onChange={setShowZeros}
            checkedChildren="Show Zeros"
            unCheckedChildren="Show Zeros"
        />}
    >
        <Row justify={'space-between'} className={'p-4'}>
            <Statistic title="Portfolio Return" value={portfolioValue*100}
                       precision={2}
                       prefix={<PrefixIcon value={portfolioValue}/>}
                       suffix={'%'}
            />
            <Statistic title="Benchmark Return" value={benchmarkValue*100}
                       precision={2}
                       prefix={<PrefixIcon value={benchmarkValue}/>}
                       suffix={'%'}
            />
        </Row>
        <div className={'px-4'}>
            <Table columns={columns} dataSource={filteredSnapshotData}/>
        </div>
    </Card>
  );
};


export const DisplayChangesPromptData = ({ data }) => {
    const extraHeaders = data[0].slice(3, );
    const rows = data.slice(1);
    return (
        <Card bordered={true} className={'gapless'}>
          {rows.map((row, index) => (
            <PortfolioSnapshotResult key={index} row={row} extraHeaders={extraHeaders} />
          ))}
        </Card>
    );
};

